// Playback rate. The value IS the multiplier the clock applies to each frame's elapsed time, so a
// full run takes PLAYBACK_DURATION_MS / speed.
enum PlaybackSpeed {
  Full = 1,
  Half = 0.5,
  Quarter = 0.25,
}

export default PlaybackSpeed;
